import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { automationsRoutes } from "@redotech/redo-merchant-automations-app/route";
import { developerChildRoutes } from "@redotech/redo-merchant-general-app/developer/routes";
import { matchPath } from "react-router-dom";
import { defaultChildRoute } from "./legacy-redirects";

/** Builders take over the page: no side nav, page header, search bar or padding. */
const FULLSCREEN_ROUTES: string[] = ["/automations/:automationId/*"];

function isFullscreen(url: string): boolean {
  return FULLSCREEN_ROUTES.some(
    (route) => !!matchPath(`/stores/:storeId/developer${route}`, url),
  );
}

export const developerRoutes: PermissionedRouteObject[] = [
  {
    path: "",
    handle: { breadcrumb: "Developer" },
    async lazy() {
      const { Page } = await import("../../page");
      return {
        element: (
          <Page
            hideHeader={isFullscreen}
            hideNavbar={isFullscreen}
            hidePadding={isFullscreen}
            hideSearchBarAndBanner={isFullscreen}
          />
        ),
      };
    },
    children: [
      defaultChildRoute("functions"),
      ...developerChildRoutes,
      { path: "automations", children: automationsRoutes },
    ],
  },
];
